import Modal from "@/common/elements/Modal";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Card from "antd/es/card/Card";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { Flex, Image, Progress, Switch, Typography } from "antd";
import axios from "axios";
import Button from "@/common/elements/Button";
import { set } from "lodash";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import { isNonEmptyVariable } from "@/util/common_function";
import useDialog from "@/hooks/useDialog";
import notificationService from "@/util/notificationService";
import bI2Official from "@/assets/BI2_block_logo_new.jpg";
import { useFilterSearchContext } from "@/contexts/FolderSearchContext";
import { ROUTES_PATH } from "@/routes";
import { useNavigate } from "react-router-dom";
import { setIrisEnrolleId, setIrisSearchId } from "@/slices/bookingsSlice";
import { useDispatch } from "react-redux";
const { Text } = Typography;

const SearchIris = forwardRef(
  (
    {
      isSearchIrisOpen,
      setisSearchIrisOpen,
      irisSearchDataEmit,
      setisIrisConnected,
    },
    ref
  ) => {
    const { showDialog } = useDialog();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isIrisAppRunning, setisIrisAppRunning] = useState(false);
    const [isCaptureInProgress, setisCaptureInProgress] = useState(false);
    const [isDeviceOpen, setisDeviceOpen] = useState(false);
    const [isScannerStarted, setisScannerStarted] = useState(false);
    const [leftEyeImageUrl, setLeftEyeImageUrl] = useState(null);
    const [rightEyeImageUrl, setRightEyeImageUrl] = useState(null);
    const [noImage, setNoImage] = useState(
      "data:image/png;base64,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"
    );
    const [lastCaptureRight, setLastCaptureRight] = useState(null);
    const [lastCaptureLeft, setLastCaptureLeft] = useState(null);
    const [leftIrisOFF, setLeftIrisOFF] = useState(false);
    const [rightIrisOFF, setRightIrisOFF] = useState(false);
    const [restartIrisLoading, setRestartIrisLoading] = useState(false);
    const [percent, setPercent] = useState(5);

    const wsRef = useRef(null);
    function connectWebSocket() {
      const ws = new WebSocket("ws://localhost:8080/ws/iris");
      wsRef.current = ws;

      ws.onopen = () => {
        console.log("🔌 WebSocket connected");
        // ws.send(JSON.stringify({ command: "openDevice" }));
      };

      ws.onmessage = (event) => {
        const msg = JSON.parse(event.data);
        if (msg.type === "status") {
          console.log("ℹ️ Status:", msg.message);
        }

        if (msg.type === "image") {
          if (msg.eye === "left") {
            setLeftEyeImageUrl(msg.data);
          } else if (msg.eye === "right") {
            setRightEyeImageUrl(msg.data);
          }

          if (!msg?.isCaptured) {
            setTimeout(() => {
              sendCommand("capture", { eye: "right" });
            }, 300);
          }
        }

        if (msg.type === "captureResult" && msg.right && msg?.left) {
          setLastCaptureRight(msg?.right);
          setLastCaptureLeft(msg?.left);
        }

        if (
          msg.type === "captureResult" &&
          msg.statusCode === 501 &&
          msg?.status === "Failed"
        ) {
          setLastCaptureRight(null);
          setLastCaptureLeft(null);
          // notificationService.error(
          //   "Iris App",
          //   "Failed to capture iris image. Please try again."
          // );
        }

        if (msg.type === "error") {
          console.error("❌", msg.message);
        }
      };

      ws.onclose = () => {
        console.log("❌ WebSocket disconnected");
        setisIrisConnected(() => false);
        wsRef.current = null;
      };

      ws.onerror = (e) => {
        console.error("WebSocket error", e);
      };
    }

    useEffect(() => {
      setTimeout(() => {
        open();
      }, 300);
    }, []);

    useEffect(() => {
      if (isSearchIrisOpen) connectWebSocket();
      return () => {
        wsRef.current?.close();
        setLeftEyeImageUrl(null);
        setRightEyeImageUrl(null);
      };
    }, [isSearchIrisOpen]);

    function sendCommand(command, data = {}) {
      if (wsRef.current?.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({ command, ...data }));
      }
    }

    function open() {
      sendCommand("openDevice");
      setisDeviceOpen(true);
      setisScannerStarted(true);
      setisIrisAppRunning(true);
    }

    function close() {
      sendCommand("closeDevice");
      setisDeviceOpen(false);
      setisScannerStarted(false);
      setisIrisAppRunning(false);
      setisSearchIrisOpen(() => false);
    }

    function captureIris() {
      apiCall();
      return;
      if (
        isNonEmptyVariable(lastCaptureRight) ||
        isNonEmptyVariable(lastCaptureLeft)
      ) {
        apiCall();
      } else {
        sendCommand("capture", { eye: "right" });
      }
      // sendCommand("capture", { eye: "right" });
    }

    const restartIris = () => {
      sendCommand("closeDevice");
      setRestartIrisLoading(true);
      setTimeout(() => {
        sendCommand("openDevice");
        setisScannerStarted(true);
        setisIrisAppRunning(true);
      }, 100);
      setTimeout(() => {
        setRestartIrisLoading(false);
      }, 4000);
    };

    useEffect(() => {
      if (
        isNonEmptyVariable(lastCaptureRight) ||
        isNonEmptyVariable(lastCaptureLeft)
      ) {
        apiCall();
      }
    }, [lastCaptureRight, lastCaptureLeft]);

    const getMessage = (enrollee_id, isLocalMatch) => {
      return (
        <>
          <p>
            <b>*NOTE</b>: The inmate just scanned has {!isLocalMatch && "no"}{" "}
            IRIS enrolled folder in the local system
            {!isLocalMatch && ", but WAS found in the national IRIS repository"}
            .
          </p>
          <p>
            Would you like to see additional info about IRIS EnrolleeID{" "}
            {enrollee_id} from the national IRIS repository?
          </p>
        </>
      );
    };

    const apiCall = () => {
      setisCaptureInProgress(true);
      let payload = null;
      if (leftIrisOFF) {
        payload = { rightImageBase64: lastCaptureRight };
      } else if (rightIrisOFF) {
        payload = { leftImageBase64: lastCaptureLeft };
      } else if (!leftIrisOFF && !rightIrisOFF) {
        payload = {
          rightImageBase64: lastCaptureRight,
          leftImageBase64: lastCaptureLeft,
        };
      }

      const intervalId = setInterval(() => {
        setPercent((prevPercent) => {
          const newPercent = prevPercent + 10;
          if (newPercent > 90) {
            return 90;
          }
          return newPercent;
        });
      }, 6000);

      api
        .post(API_ENDPOINTS.irisSearch, payload)
        .then((res) => {
          if (res?.data?.enrolledIrisList?.length) {
            let resData = res?.data?.enrolledIrisList?.[0];
            resData = {
              ...resData,
              isLocalDataMatched: res?.data?.isLocalDataMatched,
            };
            dispatch(setIrisSearchId(resData?.transactionId || 0));
            dispatch(setIrisEnrolleId(resData?.enrolleeId || 0));
            if (resData.enrolleeId !== 0) {
              const isLocalMatch = res?.data?.isLocalDataMatched;
              showDialog("confirm", {
                title: `${
                  isLocalMatch ? "Local Iris Match!" : "National Iris Match!"
                }`,
                content: getMessage(resData?.enrolleeId, isLocalMatch),
                onConfirm: () => {
                  irisSearchDataEmit(res?.data);
                  closeModal();
                },
                onCancel: () => {
                  dispatch(setIrisSearchId(0));
                  dispatch(setIrisEnrolleId(0));
                  closeModal();
                },
                confirmButtonText: "Yes",
                cancelButtonText: "No",
              });
            } else {
              dispatch(setIrisSearchId(res?.data?.searchId || 0));
              noDataFound();
            }
          } else {
            dispatch(setIrisSearchId(res?.data?.searchId || 0));
            noDataFound();
          }
        })
        .catch((err) => {
          console.error("🚀 ~ apiCall ~ err:", err);
          notificationService.error(
            "Iris Search",
            "An error occurred while searching for iris data."
          );
          irisSearchDataEmit(null);
          closeModal();
        })
        .finally(() => {
          setPercent(100);
          setTimeout(() => {
            setPercent(0);
            setisCaptureInProgress(false);
          }, 200);
          clearInterval(intervalId);
        });
    };

    const noDataFound = () => {
      showDialog("confirm", {
        title: "Record Not Found",
        content: (
          <div>
            <p>No iris records found</p>
            <p>Do you want to create new bookings</p>
          </div>
        ),
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          irisSearchDataEmit(null);
          closeModal();
        },
        onCancel: () => {
          irisSearchDataEmit(null);
          closeModal();
          dispatch(setIrisSearchId(0));
          dispatch(setIrisEnrolleId(0));
        },
      });
    };

    const closeModal = () => {
      if (isCaptureInProgress) {
        return;
      }
      close();
    };

    return (
      <>
        {isSearchIrisOpen && (
          <Modal
            header={"Search Iris"}
            show={isSearchIrisOpen}
            size="xl"
            onHide={closeModal}
            footerCloseAction={closeModal}
            footerCloseActionText="Close"
            footerActionsNeed={false}
          >
            {/* <StyledGridRow gutter={[16, 16]}>
              <StyledGridCol>
               <Button
                  color="primary"
                  type="primary"
                  variant="solid"
                  onClick={open}
                  disabled={isDeviceOpen || (leftIrisOFF && rightIrisOFF)}
                >
                  START
                </Button>
              </StyledGridCol> */}
            {/* <StyledGridCol>
              <Button
                color="primary"
                type="primary"
                variant="solid"
                onClick={captureIris}
                // disabled={!isScannerStarted || (leftIrisOFF && rightIrisOFF)}
                // loading={isCaptureInProgress}
              >
                Capture
              </Button>
            </StyledGridCol> */}
            {/*  <StyledGridCol>
                <Button
                  color="primary"
                  type="primary"
                  variant="solid"
                  onClick={restartIris}
                  disabled={!isScannerStarted || (leftIrisOFF && rightIrisOFF)}
                  loading={restartIrisLoading}
                >
                  Restart
                </Button>
              </StyledGridCol>
              <StyledGridCol>
                <img
                  alt="BI2 Logo"
                  className="footer-logo company-logo"
                  src={bI2Official}
                />
              </StyledGridCol>
            </StyledGridRow> */}

            <StyledGridRow gutter={[16, 16]}>
              <>
                <StyledGridCol span={12}>
                  <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title="RIGHT EYE IRIS"
                    // extra={
                    //   <Switch
                    //     checkedChildren="ON"
                    //     unCheckedChildren="OFF"
                    //     checked={!rightIrisOFF}
                    //     onChange={(checked) => {
                    //       setRightIrisOFF(!checked);
                    //     }}
                    //   />
                    // }
                  >
                    {!rightIrisOFF && (
                      <Image
                        id="reye"
                        width={500}
                        src={rightEyeImageUrl || noImage}
                        preview={rightEyeImageUrl ? true : false}
                      />
                    )}
                  </Card>
                </StyledGridCol>
                <StyledGridCol span={12}>
                  <Card
                    style={{ marginTop: 16 }}
                    type="inner"
                    title="LEFT EYE IRIS"
                    // extra={
                    //   <Switch
                    //     checkedChildren="ON"
                    //     unCheckedChildren="OFF"
                    //     checked={!leftIrisOFF}
                    //     onChange={(checked) => {
                    //       setLeftIrisOFF(!checked);
                    //     }}
                    //   />
                    // }
                  >
                    {!leftIrisOFF && (
                      <Image
                        id="reye"
                        width={500}
                        src={leftEyeImageUrl || noImage}
                        preview={leftEyeImageUrl ? true : false}
                      />
                    )}
                  </Card>
                </StyledGridCol>
              </>
            </StyledGridRow>
            <hr style={{ border: "2px solid red" }} />
            <StyledGridRow gutter={16} style={{ marginBottom: "1em" }}>
              <StyledGridCol span={4}>
                <Flex
                  gap="middle"
                  align="start"
                  justify="space-between"
                  horizontal
                >
                  <Flex gap="middle" align="center" justify="flex-start">
                    <img
                      alt="BI2 Logo"
                      style={{ width: "3em" }}
                      // className="footer-logo company-logo"
                      src={bI2Official}
                    />
                    <Flex align="end" vertical>
                      <Text strong>Powered By</Text>
                      <Text strong>BI2 Technologies</Text>
                    </Flex>
                  </Flex>
                  <Flex gap="middle"></Flex>
                </Flex>
              </StyledGridCol>
              <StyledGridCol span={20}>
                {isCaptureInProgress && (
                  <Progress percent={percent} type="line" status="active" />
                )}
              </StyledGridCol>
            </StyledGridRow>
          </Modal>
        )}
      </>
    );
  }
);

export default SearchIris;
